<template>
  <Row>
    <Avatar :size="50" :src="image" slot="left" />
    {{ title }}
    <!-- <FontAwesomeIcon class="ml-4" icon="stopwatch" slot="right" /> -->
    <Button flat slot="right" @click.stop="selectRecipe">Select</Button>
  </Row>
</template>

<script>
export default {
  name: "RecipeRow",
  components: {},
  props: {
    recipe: {
      type: Object,
      default: () => ({
        title: "Meal deal from coop",
        image: "https://images.unsplash.com/photo-1555985202-12975b0235dc"
      })
    }
  },
  computed: {
    image() {
      return this.recipe.image;
    },
    title() {
      return this.recipe.title;
    }
  },
  data() {
    return {
      import_to_file: ""
    };
  },
  methods: {
    selectRecipe() {
      this.$modal.hide("MyRecipesModal", {
        recipe: this.recipe
      });
    }
  },
  created() {}
};
</script>

<style></style>
